var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreakRepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.4861,
    fill: "#49433B",
    stroke: "#FFBB45",
    strokeWidth: 1.02778,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8688 11.8155C23.7778 11.437 23.2972 11.3105 23.0219 11.5857L20.6245 13.9826L18.0219 13.9826V11.381L20.4193 8.98415C20.6947 8.70899 20.5681 8.2284 20.1896 8.13761C19.4477 7.95939 18.6443 7.9463 17.8119 8.14539C15.8874 8.6056 14.3857 10.2398 14.0787 12.1933C13.9157 13.0051 13.994 13.816 14.2383 14.5485L8.66051 20.1242C7.77983 21.0046 7.77983 22.4312 8.66051 23.3113C9.07266 23.7527 9.64892 24 10.1982 24C10.7476 24 11.352 23.7799 11.7927 23.3397L17.3705 17.764C18.1052 18.0062 18.9148 18.0846 19.756 17.952C21.7106 17.6439 23.3451 16.1425 23.8055 14.2202C24.0598 13.3589 24.0473 12.5574 23.8688 11.8155ZM10.477 22.2468C10.062 22.2468 9.72534 21.9103 9.72534 21.4955C9.72534 21.0803 10.062 20.7441 10.477 20.7441C10.8919 20.7441 11.2286 21.0803 11.2286 21.4955C11.2286 21.9118 10.8919 22.2468 10.477 22.2468Z",
    fill: "#FFBB45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakRepair);
export default __webpack_public_path__ + "static/media/streak-repair.52ed2491dfee56f7ad475f6212a4e9b2.svg";
export { ForwardRef as ReactComponent };